import Swiper from 'swiper';
import {Pagination, Navigation, Autoplay} from 'swiper/modules';
Swiper.use([Pagination, Navigation, Autoplay]);

$('.community-slider-container').each(function(index, el) {
    const $container = $(this);
    const swiperElement = $container.find('.swiper')[0]; // Get the DOM element
    
    if (!swiperElement) return; // Skip if element not found
    
    new Swiper(swiperElement, {
        spaceBetween: 30,
        pagination: {
            el: $container.find('.swiper-pagination')[0],
            clickable: true,
        },
        breakpoints: {
            200: { slidesPerView: 1, spaceBetween: 25 },
            500: { slidesPerView: 2, spaceBetween: 25 },
            800: { slidesPerView: 3 },
        }
    });
});
